<script>
    import { fade } from 'svelte/transition'

    export let title = null
    export let property
    export let style = "message"
</script>
{#if property}
    {#if style === "message"}
        <div class="ui tiny message">
            {#if title}
                <div class="header">{title}</div>
            {/if}
            {#each property as msg}
                <p>&middot; {msg}</p>
            {/each}
        </div>
    {:else if style === "label"}
        <div class="ui pointing red basic label">
            {#each property as msg}
                <p>{msg}</p>
            {/each}
        </div>
    {/if}
{/if}
<style>
    .ui.message {
        background: transparent;
        opacity: 60%;
    }

    .ui.basic.red.label {
        color: #9f3a38 !important;
        border-color: #9f3a38 !important;
    }
</style>

